import GalleryTable from "components/Admin/Tables/GalleryTable";
import React from "react";
import styled from "styled-components/macro";
import Widget from "../Widget";

interface GalleryWidgetProps {}

const GalleryWidget: React.FC<GalleryWidgetProps> = ({}) => {
  return (
    <Widget title="Галерия">
      <GalleryTable />
    </Widget>
  );
};

export default GalleryWidget;
